import React from "react"
//import Img from "gatsby-image"
import kebabCase from "lodash/kebabCase"
import _ from "lodash"

import SEO from "./seo"

import * as styles from"./post.module.scss"

import { Link } from "gatsby"

import * as headStyles from "./cardlist.module.scss"
import TagMenu from "./tagMenu"

import ReactGA from "react-ga"

import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faTwitter, faFacebook } from "@fortawesome/free-brands-svg-icons"
import getTimeToRead from "../utils/timeToRead"

const eventLogger = function ({ category, action, label }) {
  ReactGA.event({
    category: category,
    action: action,
    label: label,
  })
}

const Post = ({ post, relatedPost }) => {
  const image = post.frontmatter.coverImg
  const tags = post.frontmatter.tags || []

  return (
    <div>
      <SEO
        title={post.frontmatter.title}
        description={post.frontmatter.description || post.excerpt}
        image={image}
        pathname={post.fields.slug}
        article
      />
      <section
        className={`${headStyles.pinnedwrap} ${headStyles.postDetail} py-80`}
      >
        <div className={headStyles.blogContentPinned}>
          <div className={headStyles.avatarPinned}>
			<img src={image} className="bs-md" alt={post.frontmatter.title}/>
          </div>
          <div className={headStyles.descriptionPinned}>
            <div className={`${headStyles.tag} ${headStyles.pinned}`}>
              {tags &&
                tags.map(tag => (
                  <Link key={tag} to={`/tags/${kebabCase(tag)}/`}> {tag} </Link>
                ))}
            </div>
            <div className={headStyles.description}>
              <h1>{post.frontmatter.title || post.fields.slug}</h1>
              <p
                className={`${headStyles.descriptiontext} ${headStyles.pinned}`}
                dangerouslySetInnerHTML={{
                  __html: post.frontmatter.description || post.excerpt,
                }}
              />
			  <div className="ass_interface"></div>
			</div>
          </div>
        </div>
      </section>
      <section className={`pt-80 ${styles.postDetail}`}>
        <div>
          <div className="grid-70-30">
            <div
              className={styles.postContent}
              dangerouslySetInnerHTML={{ __html: post.html }}
            />
            <div className={styles.sidebar}>
              {relatedPost.length ? (
                <div>
                  <div className={styles.relatedPost}>
                    <h3>Related Posts</h3>
                    {relatedPost.map(({ node }, i) => (
                      <div className={styles.relatedPostRow}>
                        <div className={styles.description}>
                          <h4>
                            <Link to={node.fields.slug} rel="prev">
                              {node.frontmatter.title}
                            </Link>
                          </h4>
                        </div>
                        <div className={styles.tag}>
                          {node.frontmatter.tags.map(tag => (
                            <Link to={`/tags/${kebabCase(tag)}/`}>
                              {tag}
                            </Link>
                          ))}
                        </div>
                      </div>
                    ))}
                  </div>
                  <hr />
                </div>
              ) : null}
              {/*<div>
                <h3>Follow Us </h3>
                <div className={styles.followBtn}>
                  <a
                    href="https://www.facebook.com/voxbal"
                    onClick={() =>
                      eventLogger({
                        category: "Social Clicks",
                        action: "Clicked on Facebook",
                        label: "Facebook",
                      })
                    }
                    target="blank"
                  >
                    <FontAwesomeIcon icon={faFacebook} title={"Facebook"} />
                    <p> on Facebook </p>
                  </a>
                  <a
                    href="https://twitter.com/voxbalofficial"
                    onClick={() =>
                      eventLogger({
                        category: "Social Clicks",
                        action: "Clicked on Twitter",
                        label: "Twitter",
                      })
                    }
                    target="blank"
                  >
                    <FontAwesomeIcon icon={faTwitter} title={"Twitter"} />
                    <p> on twitter </p>
                  </a>
                </div>
              </div>
<hr />*/}
              <TagMenu />
            </div>
          </div>
        </div>

        {/*<div id="commento"></div>*/}
      </section>
    </div>
  )
}

export default Post
